










































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import axios from 'axios';
import env from '@/env';

@Component({})
export default class HashDialog extends Vue {
  @Prop()
  show!: boolean;

  @Watch('show')
  onShowChange(newVal: boolean) {
    if (newVal) {
      this.rows = [];
      this.calculateHashes();
    }
  }

  private rows: any[] = [];

  private async calculateHashes() {
    const { data: rows } = await axios.get(`${env.backend_url}/cutoverplan/hashes`);
    this.rows = rows;
  }

  private saveHashes() {
    this.rows.forEach(async (row) => {
      await axios.post(`${env.backend_url}/cutoverplan/hash`, row);
      row.oldHash = row.hash;
    });
  }
}
